export default __webpack_public_path__ + "static/media/icon-calendar-plus.22345d7e.svg";